/* tslint:disable */
 
import { GenericLink } from './generic-link';
import { SidebarServiceStatus } from './sidebar-service-status';
export class SidebarDtoV2 {
  links?: Array<GenericLink>;
  serviceViewsStatus?: null | SidebarServiceStatus;
}
